import { useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import { ControlledTextArea } from "components/inputs";
import type { MiscServiceType } from "types/DataTypes";
import { SERVICE_TYPE } from "types/DataTypes";
import { usePatchMiscServiceApiByIdMutation } from "services/misc-api.ts";
import { usePatchDocumentManagementFileByIdMutation } from "services/document-management-api";

const ConsultingNotesForm = ({ service }: { service: MiscServiceType }) => {
  const [patchMiscServiceApiById] = usePatchMiscServiceApiByIdMutation();
  const [patchDocumentManagementFileById] =
    usePatchDocumentManagementFileByIdMutation();

  const onSave = useCallback(
    async (field: keyof MiscServiceType, value: string) => {
      if (service?.id) {
        if (service.type === SERVICE_TYPE.DOCUMENT_MANAGEMENT) {
          await patchDocumentManagementFileById({
            documentManagementFileId: service?.id?.toString(),
            data: { [field]: value },
          });
        } else {
          await patchMiscServiceApiById({
            id: service?.id?.toString(),
            data: { [field]: value },
          });
        }
      }
    },
    [service?.id, patchMiscServiceApiById, patchDocumentManagementFileById],
  );

  const {
    reset,
    control,
    formState: { errors },
  } = useForm<MiscServiceType>();

  useEffect(() => {
    reset({
      notes: service?.notes,
    });
  }, [service]);

  return (
    <div className={`card form audit-and-consulting-card`}>
      <div className="card__header">Notes</div>
      <div className="card__children">
        <ControlledTextArea
          name="notes"
          control={control}
          classNames="d-block"
          advancedEdit={true}
          label={null}
          onSave={(value) => onSave("notes", String(value))}
          errors={errors}
        />
      </div>
    </div>
  );
};

export default ConsultingNotesForm;
